import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result, UseCase } from '@digibricks/core';
export var DELETE_SUB_QUESTION_AND_CORRECT_ANSWER_USE_CASE = 'DELETE_SUB_QUESTION_AND_CORRECT_ANSWER_USE_CASE';
export var DeleteSubQuestionAndCorrectAnswerUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(DeleteSubQuestionAndCorrectAnswerUseCase, _UseCase);

  var _super = _createSuper(DeleteSubQuestionAndCorrectAnswerUseCase);

  function DeleteSubQuestionAndCorrectAnswerUseCase() {
    _classCallCheck(this, DeleteSubQuestionAndCorrectAnswerUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(DeleteSubQuestionAndCorrectAnswerUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var currentQuestion, subQuestionId, deletedResult, totalScore;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentQuestion = input.currentQuestion, subQuestionId = input.subQuestionId;
                deletedResult = currentQuestion.deleteSubQuestionAndCorrectAnswer(subQuestionId);

                if (!deletedResult.isFailure) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", mappingResultError(deletedResult));

              case 4:
                totalScore = currentQuestion.correctAnswers.reduce(function (a, b) {
                  return a + b.score;
                }, 0);
                currentQuestion.updateScore(totalScore);
                return _context.abrupt("return", Result.ok(currentQuestion));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return DeleteSubQuestionAndCorrectAnswerUseCase;
}(UseCase);